module.exports = "/ui/fonts/slick.woff";